import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IProductBuyBulkTransactionForm } from "../../data/product_buy_transaction_entity";
import { ProductBuyTransactionForm } from "../components/product_buy_bulk_form";
import { transactionRedux } from "../state/state";

export const ProductBuyTransactionCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (values: IProductBuyBulkTransactionForm): Promise<void> => {
    await dispatch(transactionRedux.actions.createBulk(values));
    history.push(ROUTES.transaction);
  };

  const createTransactionBranch = useSelector<IAppReduxState, IAsyncData<any>>((state) => state.transaction.createBulk);

  return (
    <ProductBuyTransactionForm
      branch={createTransactionBranch}
      onSubmit={onSubmit}
      initialData={null}
      submitTitle="Create"
    />
  );
};
